export const setNewRelicAppId = (appId?: string) => {
  if (typeof window === 'undefined' || !appId) {
    return;
  }

  if (!window.NREUM) {
    window.NREUM = {};
  }

  if (!window.NREUM.loader_config) {
    window.NREUM.loader_config = {};
  }

  window.NREUM.loader_config.applicationID = appId;

  if (window.NREUM.loader_config.agentID === undefined || window.NREUM.loader_config.agentID === '') {
    window.NREUM.loader_config.agentID = appId;
  }

  if (!window.NREUM.info) {
    window.NREUM.info = {};
  }

  window.NREUM.info.applicationID = appId;

  if (window.NREUM.info.agentID === undefined || window.NREUM.info.agentID === '') {
    window.NREUM.info.agentID = appId;
  }
};
